import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Comment / speech bubble — three dots inside a rounded bubble pulse
 *  sequentially, suggesting an active reply being typed. The bubble's
 *  tail drops to the bottom-left so it reads as a quote pinned to a
 *  paragraph rather than a generic chat icon. */
export function IcnComment(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="comment">
      <path d="M4 3h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2H7l-2.5 2.5V11H4a2 2 0 0 1 -2 -2V5a2 2 0 0 1 2 -2z" />
      <circle cx="5" cy="7" r="0.6" fill="currentColor" stroke="none">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.3;1;0.3;0.3"
            keyTimes="0;0.2;0.6;1"
            dur="1.6s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="8" cy="7" r="0.6" fill="currentColor" stroke="none">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.3;0.3;1;0.3;0.3"
            keyTimes="0;0.2;0.4;0.7;1"
            dur="1.6s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="11" cy="7" r="0.6" fill="currentColor" stroke="none">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.3;0.3;0.3;1;0.3"
            keyTimes="0;0.4;0.55;0.75;1"
            dur="1.6s"
            repeatCount="indefinite"
          />
        )}
      </circle>
    </Svg>
  );
}
